(function ($) {
  var elementorHookRegistered = false;
  var widgetSelector = '[data-posts-featured]';
  var sliderSelector = '[data-posts-featured-slider]';
  var arrowMarkup = '<button type="button" class="slick-prev"><svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#FFFFFF"/><path d="M25 43.6667H62.3333M62.3333 43.6667L43.6667 25M62.3333 43.6667L43.6667 62.3333" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

  function getPostsFeaturedWidgets($scope) {
    if ($scope.is(widgetSelector)) {
      return $scope;
    }

    return $scope.find(widgetSelector);
  }

  function initPostsFeatured($scope) {
    getPostsFeaturedWidgets($scope).each(function () {
      $(this).find(sliderSelector).each(function () {
        var $slider = $(this);

        if ($slider.hasClass('slick-initialized')) {
          return;
        }

        $slider.slick({
          autoplay: false,
          arrows: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: arrowMarkup,
          nextArrow: arrowMarkup,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      });
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/post-featured.default',
      initPostsFeatured
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initPostsFeatured($(document));
  });
})(jQuery);
